(ns practitest.frontend.milestone.readiness-index.events
  (:require [practitest.frontend.common.re-frame :as rf-common]))

(def Metrics
  [:map
   [:metrics/rrqi [:maybe number?]]
   [:metrics/ccs  [:maybe number?]]
   [:metrics/ecs  [:maybe number?]]
   [:metrics/rdrs [:maybe number?]]
   [:metrics/executed-per-day
    [:maybe
     [:vector
      [:map
       [:date  number?]
       [:value number?]]]]]])

(defn transform [_evt {:keys [rrqi ccs ecs rdrs executed-per-day trimester]}]
  #:metrics
  {:rrqi             rrqi
   :ccs              ccs
   :ecs              ecs
   :rdrs             rdrs
   :trimester        trimester
   :executed-per-day (some->> executed-per-day
                              (mapv #(update % :date (fn [d] (.getTime (js/Date. d))))))})

(def load-readiness-index
  {:evt          ::fetch
   :db-path      [:milestones]
   :schema       Metrics
   :transform    transform
   :update-only? true})

(rf-common/reg-load-data-events load-readiness-index)
